<div class="withdrawal-instruction-card d-flex justify-content-between align-items-center">
  <div class="d-flex flex-column gap-1">
    <div class="d-flex align-items-center gap-2">
      <div class="dot" [style.background-color]="instruction.fund | investmentInstructionFundColour"></div>
      <span class="fund-name">{{ instruction.fund?.name }}</span>
    </div>
    <span class="fund-balance">{{ instruction.fundBalance | currency }}</span>
  </div>
  <span class="fund-percentage">{{ instruction.percentage | number : '1.2-2' }}%</span>
</div>
